// EXPERIMENT #171270395

import React from 'react';
import PropTypes from 'prop-types';
import GoogleSignupCta from 'components/signup_modal/google_signup_cta';
import LeadFormWithPassword from './lead_form_with_password';
import CompanyLeadShape from '../constants/CompanyLeadShape';
import { getAnswersFromStorage } from '../storage_helpers';

const Header = ({ wasAnswerReset }) => {
  if (wasAnswerReset) {
    return (
      <div className="col-12 text-center">
        <h4>Good news! Gusto could be a great fit for your business.</h4>
        <p>
          Based on what you’ve told us, we think you’re going to love payroll and benefits with
          Gusto.
        </p>
      </div>
    );
  }
  return <h4 className="col-12 text-center">Great! Let’s get you set up.</h4>;
};

Header.propTypes = {
  wasAnswerReset: PropTypes.bool,
};

Header.defaultProps = {
  wasAnswerReset: false,
};

const LpHeader = () => (
  <>
    <div className="col-12 text-center text-large padding-bottom-10px">
      <span className="text-large-bold">Nice!</span> We could be a great fit for your business.
    </div>
  </>
);

const ReferralModalHeader = () => (
  <>
    <h1 className="col-12 text-center h4">Great! Let’s get you set up.</h1>
    <p className="text-center">
      After you run your first paid payroll, you’ll receive a{' '}
      {window.refereeReward?.refereeAmount || ''} {window.refereeReward?.giftCardType || ''} gift
      card.
    </p>
  </>
);

const getWasAnswerReset = () => {
  const surveyAnswers = getAnswersFromStorage();
  return surveyAnswers.wasReset;
};

const renderHeader = headerType => {
  switch (headerType) {
    case 'landingPage':
      return <LpHeader />;
    case 'referralModal':
      return <ReferralModalHeader />;
    case 'default':
      return <Header wasAnswerReset={getWasAnswerReset()} />;
    default:
      throw Error(`Unexpected headerType ${headerType}`);
  }
};

const Divider = () => (
  <div className="padding-bottom-10px padding-top-10px">
    <div className="google-signup-or text-center overflow-hidden">
      <span>or</span>
    </div>
  </div>
);

const Terms = () => (
  <div className="text-small c-black-900">
    By creating an account, you agree to the{' '}
    <a href="/about/terms" target="_blank">
      terms & conditions
    </a>
    , the{' '}
    <a href="/about/terms/payroll" target="_blank">
      payroll terms
    </a>
    , and our{' '}
    <a href="/about/privacy" target="_blank">
      privacy policy
    </a>
    .
  </div>
);

const Footer = () => (
  <>
    <div className="margin-bottom-15px">
      Already use Gusto? <a href={window.loginBaseUrl}>Sign in here</a>.
    </div>
    <Terms />
  </>
);

const SignupForm = ({ contractorOnly, fromGoogleSSO, companyLead, headerType }) => {
  return (
    <div className="survey-signup-form row">
      {renderHeader(headerType)}

      <div className="d-flex flex-column justify-content-between col-12">
        <div className="padding-top-10px width-100">
          {!fromGoogleSSO && (
            <div>
              <GoogleSignupCta
                googleSignupBaseUrl="/google_sso/homepage_survey_signup/new"
                googleButtonLabel="Sign up with Google"
              />
              <Divider />
            </div>
          )}
          <LeadFormWithPassword
            contractorOnly={contractorOnly}
            companyLead={companyLead}
            fromGoogleSSO={fromGoogleSSO}
            submissionOrigin={headerType === 'referralModal' ? 'referral_modal' : headerType}
          />
          <div className="d-block margin-top-25px">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

SignupForm.propTypes = {
  contractorOnly: PropTypes.bool.isRequired,
  fromGoogleSSO: PropTypes.bool.isRequired,
  companyLead: CompanyLeadShape.isRequired,
  headerType: PropTypes.oneOf(['default', 'landingPage', 'referralModal']),
};

SignupForm.defaultProps = {
  headerType: 'default',
};

export { SignupForm, Footer };
